import React, {useState} from 'react';
import { Link } from "react-router-dom";
import Searchbar from './components/Searchbar';
import pictureLogo from '../../../images/logo.png';
import pictureShortLogo from '../../../images/logo_symbole.png'
import NavbarConnect from "./components/NavbarConnect";
import SubNavbar from "./components/SubNavbar";
import {useBreakpoint} from "../../../libs/breakpoint";
import {useLocation, useNavigate} from "react-router-dom";

const NavBar = ({
            initUser = false
    }) => {
    const location = useLocation();
    let navigate = useNavigate();

    const [toggleSearchBar, setToggleSearchBar] = useState(false);
    const breakpoints = useBreakpoint();
    let isMobile = !!breakpoints.md;

    return (
        <header>
            <div className="navbar-header-wrapper">
                <div className="container navbar-header">
                    <h1 className="logo-navbar">
                        <Link to="/" title={"Voissa"} rel="nofollow noopener noreferrer" >
                            <img src={isMobile ? pictureShortLogo : pictureLogo} alt="Voissa"/>
                        </Link>
                    </h1>
                    <Searchbar className={!initUser ? 'not-logged' : ''}
                       handleSearchBarDisplay={(toggle) => setToggleSearchBar(toggle)}
                       location={location}
                       navigate={navigate}
                       currentUserInitialized={initUser}
                    />
                    <NavbarConnect
                        showSearchBar={!isMobile ? false : toggleSearchBar}/>
                </div>
            </div>
            <SubNavbar />
        </header>
    );
}
export default NavBar;